import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { NotificationService } from '@shared/services/notification.service'

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: `
    <router-outlet />

    @if (notification.notification()) {
      <div class="global-notification" [class]="'notification--' + notification.notification()!.type">
        <strong>{{ notification.notification()!.title }}</strong>
        <p>{{ notification.notification()!.text }}</p>
      </div>
    }
  `,
  styles: [`
    .global-notification {
      position: fixed;
      bottom: 1.5rem;
      right: 1.5rem;
      max-width: 360px;
      padding: 1rem 1.25rem;
      border-radius: 10px;
      box-shadow: 0 4px 20px rgba(0,0,0,0.15);
      z-index: 9999;

      strong { display: block; font-weight: 700; margin-bottom: 0.25rem; }
      p { margin: 0; font-size: 0.9rem; }
    }

    .notification--error   { background: #fee2e2; color: #991b1b; border-left: 4px solid #ef4444; }
    .notification--success { background: #d1fae5; color: #065f46; border-left: 4px solid #10b981; }
    .notification--warning { background: #fef3c7; color: #92400e; border-left: 4px solid #f59e0b; }
    .notification--info    { background: #dbeafe; color: #1e3a8a; border-left: 4px solid #3b82f6; }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class App {
  protected readonly notification = inject(NotificationService)
}
